import React from 'react';
import { RHFTextField } from '@/commons/hook-form';
import { Control, useFieldArray } from 'react-hook-form';
import { Accordion, AccordionDetails, AccordionSummary, Chip, Stack } from '@mui/material';
import { parseUserDate, translates } from '@/utils';
import { Iconic } from '@/commons/iconic';
import { commonTableDateFormat } from '@/utils/constants';
import { FormFields } from '.';

interface Props {
  control: Control<FormFields>;
}

export const DiscountFormFields = ({ control }: Props) => {
  const { fields } = useFieldArray({
    name: 'ordersDetails',
    control,
  });

  return (
    <>
      {fields.map((orderDetail, index) => (
        <Accordion key={orderDetail.id}>
          <AccordionSummary expandIcon={<Iconic icon="eva:arrow-ios-downward-fill" />}>
            <p>{`${orderDetail.product.name} (${orderDetail.quantity})`}</p>
          </AccordionSummary>

          <AccordionDetails>
            <Stack sx={{ gap: 2 }}>
              <Chip
                label={parseUserDate(orderDetail.createdAt).format(commonTableDateFormat)}
                sx={{ justifyContent: 'left' }}
              />
              <Chip label={orderDetail.description || 'Sin descripcion'} sx={{ justifyContent: 'left' }} />

              <RHFTextField
                name={`ordersDetails.${index}.quantity_discount`}
                type="number"
                label={translates.quantity_discount}
              />

              <RHFTextField
                name={`ordersDetails.${index}.discount`}
                type="number"
                label={translates.discount}
              />
            </Stack>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};
